module.exports = __webpack_public_path__ + "static/media/bt-classifications-square.2db407cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/bt-classifications-square.jpg
// module id = 684
// module chunks = 0